import { api } from '../../api/api';
import {
  PEER_REQUEST, GET_PEER_UNASSIGNED_SUCCESS, GET_PEER_CONNECTED_SUCCESS,
  PEER_TUNNEL_STATUS_SUCCESS, PEER_WG_HEALTH_SUCCESS, GET_APP_VERSIONS_SUCCESS,
  PEER_FLAG_OFF, PEER_REQUEST_FAILED, ASSIGN_PEER_DEVICE_SUCCESS,
} from '../constant';

export const getUnassignedPeers = (storeId) => async (dispatch) => {
  dispatch({ type: PEER_REQUEST });
  try {
    const res = await api.get(`/peer/unassigned/${storeId}`);
    dispatch({ type: GET_PEER_UNASSIGNED_SUCCESS, payload: res.data?.screens || res.data || [] });
  } catch (e) {}
};

export const getConnectedPeers = (userId) => async (dispatch) => {
  dispatch({ type: PEER_REQUEST });
  try {
    const res = await api.get(`/peer/connected/${userId}`);
    dispatch({ type: GET_PEER_CONNECTED_SUCCESS, payload: res.data?.screens || res.data || [] });
  } catch (e) {}
};

export const assignPeerDevice = (screenId, data) => async (dispatch) => {
  try {
    const res = await api.post(`/peer/assign/${screenId}`, data);
    if (res.status === 201) dispatch({ type: ASSIGN_PEER_DEVICE_SUCCESS, payload: res.data });
  } catch (e) {}
};

export const removePeerDevice = (screenId) => async (dispatch) => {
  try {
    await api.delete(`/peer/remove/${screenId}`);
    dispatch({ type: 'REMOVE_PEER_DEVICE', payload: screenId });
  } catch (e) {}
};

export const getTunnelStatus = () => async (dispatch) => {
  try {
    const res = await api.get('/peer/tunnel-status');
    dispatch({ type: PEER_TUNNEL_STATUS_SUCCESS, payload: res.data });
  } catch (e) {}
};

export const getWgHealth = () => async (dispatch) => {
  try {
    const res = await api.get('/peer/wg-health');
    dispatch({ type: PEER_WG_HEALTH_SUCCESS, payload: res.data });
  } catch (e) {}
};

export const getAppVersions = (query) => async (dispatch) => {
  try {
    const params = new URLSearchParams();
    if (query) {
      Object.keys(query).forEach(key => {
        if (query[key]) params.set(key, query[key]);
      });
    }
    const q = params.toString();
    const url = q ? `/peer/app-versions?${q}` : '/peer/app-versions';
    const res = await api.get(url);
    dispatch({ type: GET_APP_VERSIONS_SUCCESS, payload: res.data?.versions || res.data || [] });
  } catch (e) {}
};

export const addAppVersion = (data) => async (dispatch) => {
  try {
    const res = await api.post('/peer/app-versions', data);
    if (res.status === 201) dispatch({ type: 'ADD_APP_VERSION_SUCCESS', payload: res.data });
  } catch (e) {}
};

export const peerFlagOff = () => (dispatch) => {
  dispatch({ type: PEER_FLAG_OFF });
};
